<header class="secondary w-100 ptb-10" id="header">
  <div class="small-nav">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-6">
          <a routerLink="/" routerLinkActive="active">
            <img
              class="nav-logo w-100 max-180"
              src="../../../../assets/images/amanda-{{ global.lang }}.svg"
              alt="website logo"
            />
          </a>
        </div>
        <div class="col-6 text-end">
          <div class="smallCart" fxHide.gt-xs>
            <a
              routerLink="/cart"
              class="me-4 ms-4"
              *ngIf="global.authenticated"
            >
              <span class="cart_numbers">{{ count }}</span>
              <img src="/assets/images/small-cart.svg" alt="cart" />
            </a>
            <button mat-icon-button (click)="onToggleSidenav()">
              <mat-icon>menu</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="large-nav">
    <div class="sub-nav pb-5 border-bottom">
      <div class="container">
        <div class="row">
          <div class="col-5 col-md-6">
            <div>
              <img
                src="assets/images/icon-whatsapp-white.svg"
                alt="whatsApp icon"
              />
              <a
                class="text-white weight-700 size-1 size-md-3 mrs-5 social-icon-item"
                href="tel:920020140"
                >{{ global?.setting?.mobile }}</a
              >
            </div>
          </div>
          <div
            class="col-7 col-md-6 d-flex justify-content-end align-items-center"
          >
            <div class="social-icons d-flex">
              <a
                class="social-icon-item bg-white rounded-circle mre-2 mre-md-4 width-30 height-30 d-flex justify-content-center align-items-center"
                href="https://goo.gl/maps/xyjfuJsdaiTL4TEu7"
              >
                <img
                  class="height-15 width-15 align-baseline"
                  src="assets/images/logo-location.svg"
                  alt="social icon"
                />
              </a>
              <a
                class="social-icon-item bg-white rounded-circle mre-2 mre-md-4 width-30 height-30 d-flex justify-content-center align-items-center"
                href="{{ global?.setting?.linkedIn }}"
              >
                <img
                  class="height-15 width-15 align-baseline"
                  src="assets/images/logo-linkedIn.svg"
                  alt="social icon"
                />
              </a>
              <a
                class="social-icon-item bg-white rounded-circle mre-2 mre-md-4 width-30 height-30 d-flex justify-content-center align-items-center"
                href="{{ global?.setting?.snapchat }}"
              >
                <img
                  class="height-15 width-15 align-baseline"
                  src="assets/images/logo-snapchat.svg"
                  alt="social icon"
                />
              </a>
              <a
                class="social-icon-item bg-white rounded-circle mre-2 mre-md-4 width-30 height-30 d-flex justify-content-center align-items-center"
                href="{{ global?.setting?.facebook }}"
              >
                <img
                  class="height-15 width-15 align-baseline"
                  src="assets/images/logo-facebook.svg"
                  alt="social icon"
                />
              </a>
              <a
                class="social-icon-item bg-white rounded-circle mre-2 mre-md-4 width-30 height-30 d-flex justify-content-center align-items-center"
                href="{{ global?.setting?.twitter }}"
              >
                <img
                  class="height-15 width-15 align-baseline"
                  src="assets/images/logo-twitter.svg"
                  alt="social icon"
                />
              </a>
              <a
                class="social-icon-item bg-white rounded-circle mre-2 mre-md-4 width-30 height-30 d-flex justify-content-center align-items-center"
                href="{{ global?.setting?.instagram }}"
              >
                <img
                  class="height-15 width-15 align-baseline"
                  src="assets/images/logo-intgram.svg"
                  alt="social icon"
                />
              </a>
            </div>
            <div class="d-none d-lg-block">
              <div
                class="text-white size-4 font-medium cursor-pointer lang"
                *ngIf="'en' == currentLang"
                (click)="changeLang('ar')"
              >
                العربية
              </div>
              <div
                class="text-white size-4 font-medium cursor-pointer lang"
                *ngIf="'ar' == currentLang"
                (click)="changeLang('en')"
              >
                English
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main-nav pt-10">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-6 col-md-2">
            <a routerLink="/" routerLinkActive="active">
              <img
                class="nav-logo w-100 max-180"
                src="../../../../assets/images/amanda-{{ global.lang }}.svg"
                alt="website logo"
              />
              <!-- <img class="nav-logo w-100 max-110" src="{{global?.setting?.logo}}"
                              alt="website logo"> -->
            </a>
          </div>
          <div class="col-6 col-md-8 d-none d-lg-block">
            <div
              class="nav-items cursor-pointer position-relative d-flex justify-content-around text-white"
            >
              <div
                style="padding-top: 5px"
                class="menu nav-item size-md-2 size-lg-5"
              >
                <div>{{ "header.services" | translate }}</div>
                <div
                  class="menu-items mrt-5 box-shadow bg-white text-primary d-flex justify-content-between p-10 border-radius-5 d-none"
                >
                  <a
                    class="menu-item mrse-5 text-center"
                    *ngFor="let s of global.services; let i = index"
                    [routerLink]="['/service', s.serviceId]"
                  >
                    <div class="hover-img">
                      <img
                        class="border-radius-5"
                        src="{{ s.thumbnail }}"
                        alt="img"
                      />
                    </div>
                    <div class="item size-1 weight-600 pt-5">
                      {{ s.name || s.nameAr }}
                    </div>
                  </a>
                </div>
              </div>
              <div
                style="padding-top: 5px"
                class="nav-item size-md-2 size-lg-5"
              >
                <a
                  class="link"
                  routerLink="about-us"
                  routerLinkActive="active"
                  >{{ "header.aboutUs" | translate }}</a
                >
              </div>
              <div
                style="padding-top: 5px"
                class="nav-item size-md-2 size-lg-5"
              >
                <a
                  class="link"
                  routerLink="session"
                  routerLinkActive="active"
                  >{{ "header.sessions" | translate }}</a
                >
              </div>
              <!-- <div
                style="padding-top: 5px"
                class="nav-item size-md-2 size-lg-5"
              >
                <a class="link" routerLink="doctor" routerLinkActive="active">{{
                  "header.doctors" | translate
                }}</a>
              </div> -->
              <!-- <div class="nav-item size-md-2 size-lg-5">
                      <a class="link" routerLink="membership" routerLinkActive="active">{{ 'header.memberships' | translate }}</a>
                    </div> -->
              <div
                style="padding-top: 5px"
                class="nav-item size-md-2 size-lg-5"
              >
                <a
                  class="link"
                  routerLink="health-education"
                  routerLinkActive="active"
                  >{{ "header.blog" | translate }}</a
                >
              </div>
              <!-- <div class="nav-item size-md-2 size-lg-5">
                              <a class="link" routerLink="news" routerLinkActive="active">{{ 'header.MediaCenter' | translate }}</a>
                          </div> -->
              <div
                style="padding-top: 5px"
                class="nav-item size-md-2 size-lg-5"
              >
                <a
                  class="link"
                  routerLink="contact-us"
                  routerLinkActive="active"
                  >{{ "header.contactUs" | translate }}</a
                >
              </div>
            </div>
          </div>

          <div
            class="col-4 col-md-2 text-end d-flex justify-content-end cartAndProfile"
          >
            <div
              class="cart__container nav-item size-md-2 size-lg-5S d-flex align-items-center me-3 ms-3"
              *ngIf="global.authenticated"
            >
              <span (click)="showCartFun()" class="cart_numbers">{{
                count
              }}</span>
              <img
                (click)="showCartFun()"
                class="cart"
                src="assets/images/cart.svg"
                alt="cart"
              />
              <div
                style="flex-direction: column; z-index: 5; cursor: auto"
                *ngIf="showCart && cartItems.length !== 0"
                class="menu-items box-shadow bg-white text-primary d-flex p-10 border-radius-5"
              >
                <div (click)="showCartFun()" class="backdrop"></div>
                <div
                  class="cart-item menu-item mrse-5 text-start"
                  *ngFor="let s of cartItems; let i = index"
                >
                  <div class="hover-img">
                    <img class="item_image" src="{{ s.image }}" alt="img" />
                  </div>
                  <div class="item size-1 weight-600 pt-5">
                    {{ s.arabic_name || s.english_name }}
                  </div>
                  <img
                    (click)="deleteItem(s.cartItemId)"
                    class="deleteIcon"
                    src="assets/images/delete.svg"
                  />
                </div>
                <hr />
                <div class="cart_bottom">
                  <h3 class="text-center">
                    {{ "totalPrice" | translate }} :
                    {{ cart.totalPrice || 0 }} ر.س
                  </h3>
                  <div class="cart-btns d-flex justify-content-center">
                    <button
                      (click)="goToCart()"
                      style="color: white"
                      class="btn bg-primary size-8 weight-600"
                    >
                      {{ "goToCart" | translate }}
                    </button>
                    <button (click)="clearCart()" class="btn size-8 weight-600">
                      {{ "clearCart" | translate }}
                    </button>
                  </div>
                </div>
              </div>
              <div
                *ngIf="showCart && cartItems.length === 0"
                style="cursor: auto"
                class="menu-items position-absolute mrt-5 box-shadow bg-white text-primary d-flex p-10 border-radius-5"
              >
                <div (click)="showCartFun()" class="backdrop"></div>
                <div class="emptyCart cart-item menu-item mrse-5 text-center">
                  {{ "emptyCart" | translate }}
                </div>
              </div>
            </div>
            <button
              class="logIn-btn bg-white text-primary ptb-2 border-0 pse-7 border-radius-5 size-4 weight-700 w-100 max-150 m-auto"
              mat-button
              (click)="openDialog()"
              *ngIf="!global.authenticated"
            >
              {{ "header.logIn" | translate }}
            </button>
            <a
              routerLink="account"
              class="d-flex align-items-center justify-content-end cursor-pointer"
              *ngIf="global.authenticated"
            >
              <div>
                <img
                  style="width: 45px; border-radius: 50%"
                  src="{{ global?.customer?.avatar }}"
                  alt="img"
                />
              </div>
              <div class="text-white mrs-5 size-7">
                {{ global?.customer?.name }}
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
